var jade = require("C:\\Dev\\repos\\player\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var jade_debug = [ new jade.DebugItem( 1, "C:\\Dev\\repos\\player\\app\\templates\\jump-to.jade" ) ];
try {
var buf = [];
var jade_mixins = {};
var jade_interp;
var self = locals || {};
jade_debug.unshift(new jade.DebugItem( 0, "C:\\Dev\\repos\\player\\app\\templates\\jump-to.jade" ));
jade_debug.unshift(new jade.DebugItem( 1, "C:\\Dev\\repos\\player\\app\\templates\\jump-to.jade" ));
buf.push("<div class=\"jump-to-wrapper\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 2, "C:\\Dev\\repos\\player\\app\\templates\\jump-to.jade" ));
buf.push("<div class=\"overlay\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 3, "C:\\Dev\\repos\\player\\app\\templates\\jump-to.jade" ));
buf.push("<div class=\"form\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 4, "C:\\Dev\\repos\\player\\app\\templates\\jump-to.jade" ));
buf.push("<div class=\"title\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 4, jade_debug[0].filename ));
buf.push("Go to");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 6, "C:\\Dev\\repos\\player\\app\\templates\\jump-to.jade" ));
buf.push("<div class=\"row\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 7, "C:\\Dev\\repos\\player\\app\\templates\\jump-to.jade" ));
buf.push("<input id=\"go-to-subtitle\" type=\"radio\" checked=\"checked\" name=\"go-to\" placeholder=\"#\" value=\"1\"/>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 8, "C:\\Dev\\repos\\player\\app\\templates\\jump-to.jade" ));
buf.push("<label for=\"go-to-subtitle\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 8, jade_debug[0].filename ));
buf.push("Subtitle");
jade_debug.shift();
jade_debug.shift();
buf.push("</label>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 9, "C:\\Dev\\repos\\player\\app\\templates\\jump-to.jade" ));
buf.push("<input type=\"text\" name=\"subtitle\" class=\"go-to-subtitle\"/>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 10, "C:\\Dev\\repos\\player\\app\\templates\\jump-to.jade" ));
buf.push("/");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 11, "C:\\Dev\\repos\\player\\app\\templates\\jump-to.jade" ));
buf.push("<span>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 11, jade_debug[0].filename ));
buf.push("0");
jade_debug.shift();
jade_debug.shift();
buf.push("</span>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 13, "C:\\Dev\\repos\\player\\app\\templates\\jump-to.jade" ));
buf.push("<div class=\"row\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 14, "C:\\Dev\\repos\\player\\app\\templates\\jump-to.jade" ));
buf.push("<input id=\"go-to-time\" type=\"radio\" name=\"go-to\"/>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 15, "C:\\Dev\\repos\\player\\app\\templates\\jump-to.jade" ));
buf.push("<label for=\"go-to-time\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 15, jade_debug[0].filename ));
buf.push("Time code");
jade_debug.shift();
jade_debug.shift();
buf.push("</label>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 16, "C:\\Dev\\repos\\player\\app\\templates\\jump-to.jade" ));
buf.push("<input type=\"text\" name=\"time\" placeholder=\"hh:mm:ss:ff\" disabled=\"disabled\" class=\"go-to-time\"/>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 17, "C:\\Dev\\repos\\player\\app\\templates\\jump-to.jade" ));
buf.push("<div class=\"row\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 18, "C:\\Dev\\repos\\player\\app\\templates\\jump-to.jade" ));
buf.push("<button type=\"button\" class=\"ok\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 18, jade_debug[0].filename ));
buf.push("Ok");
jade_debug.shift();
jade_debug.shift();
buf.push("</button>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 19, "C:\\Dev\\repos\\player\\app\\templates\\jump-to.jade" ));
buf.push("<button type=\"button\" class=\"cancel\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 19, jade_debug[0].filename ));
buf.push("Cancel");
jade_debug.shift();
jade_debug.shift();
buf.push("</button>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();
buf.push("</div>");
jade_debug.shift();
jade_debug.shift();;return buf.join("");
} catch (err) {
  jade.rethrow(err, jade_debug[0].filename, jade_debug[0].lineno, ".jump-to-wrapper\r\n\t.overlay\r\n\t.form\r\n\t\t.title Go to\r\n\r\n\t\t.row\r\n\t\t\tinput#go-to-subtitle(type=\"radio\", checked=\"checked\", name=\"go-to\", placeholder=\"#\", value=\"1\")\r\n\t\t\tlabel(for=\"go-to-subtitle\") Subtitle\r\n\t\t\tinput.go-to-subtitle(type=\"text\", name=\"subtitle\")\r\n\t\t\t| /\r\n\t\t\tspan 0\r\n\r\n\t\t.row\r\n\t\t\tinput#go-to-time(type=\"radio\", name=\"go-to\")\r\n\t\t\tlabel(for=\"go-to-time\") Time code\r\n\t\t\tinput.go-to-time(type=\"text\", name=\"time\", placeholder=\"hh:mm:ss:ff\", disabled)\r\n\t\t.row\r\n\t\t\tbutton.ok(type=\"button\") Ok\r\n\t\t\tbutton.cancel(type=\"button\") Cancel");
}
}


//////////////////
// WEBPACK FOOTER
// ./app/templates/jump-to.jade
// module id = 416
// module chunks = 0